import * as ScholarshipAwardDurationStoreActions from './scholarshipawardduration.actions';
import * as ScholarshipAwardDurationStoreSelectors from './scholarshipawardduration.selectors';
import * as ScholarshipAwardDurationStoreReducer from './scholarshipawardduration.reducer';

export {
	ScholarshipAwardDurationStoreActions,
	ScholarshipAwardDurationStoreSelectors,
	ScholarshipAwardDurationStoreReducer
};
